import React, { useState } from 'react';
import { useAuthProvider } from '../../providers/AuthProvider';

const EditDefectOverlay = ({ defect, setShowDefects, updateDefect, theme }) => {
    const { isDev, permissions } = useAuthProvider();
    const canEdit = isDev || permissions.perm_defects_edit;
    const [repair, setRepair] = useState({
        defect_uuid: defect.defect_uuid,
        vehicle_check_uuid: defect.vehicle_check_uuid,
        defect_type: defect.defect_type,
        repair_status: defect.status === 'failed' ? 'unrepaired' : 'repaired',
        repair_comment: defect.comment || '',
    });
    const [showError, setShowError] = useState(false);
    const [showStatusError, setShowStatusError] = useState(false);

    return (
        <div
            role="dialog"
            aria-labelledby="repair-title"
            aria-describedby="repair-description"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
            }}
            onClick={() => setShowDefects(false)}
        >
            <div
                style={{
                    backgroundColor: '#333',
                    color: '#fff',
                    padding: '20px',
                    borderRadius: '10px',
                    width: '400px',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h3 id="repair-title">{canEdit ? 'Edit Defect' : 'View Defect Details'}</h3>
                <p><strong>Type:</strong> {defect.defect_type}</p>
                <fieldset disabled={!canEdit} style={{ border: 'none', padding: 0, margin: 0, display: 'contents' }}>
                <div style={{ marginTop: '10px' }}>
                    <label>Status:</label>
                    <select
                        value={repair.repair_status}
                        onChange={(e) =>
                            setRepair({
                                ...repair,
                                repair_status: e.target.value,
                            })
                        }
                        style={{
                            marginTop: '5px',
                            padding: '5px',
                            width: '100%',
                        }}
                    >
                        <option value="repaired">Repaired</option>
                        <option value="unrepaired">Unrepaired</option>
                    </select>
                </div>

                <div style={{ marginTop: '10px' }}>
                    <label>Comment:</label>
                    <textarea
                        value={repair.repair_comment}
                        onChange={(e) => {
                            setShowError(false);
                            setRepair({
                                ...repair,
                                repair_comment: e.target.value,
                            });
                        }}
                        rows={4}
                        style={{
                            width: '100%',
                            padding: '5px',
                            marginTop: '5px',
                        }}
                    />
                </div>
                </fieldset>
                {showStatusError && (
                    <div style={{ marginTop: '10px', textAlign: 'center', color: '#fc4a4a', padding: '5px' }}>
                        Please change the status to 'Repaired' to update a vehicle defect!!
                    </div>
                )}                    
                {showError && (
                    <div style={{ marginTop: '10px', textAlign: 'center', color: '#fc4a4a' }}>
                        Please enter a comment!!
                    </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%' }}>
                    {canEdit && (
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                setShowStatusError(false);
                                setShowError(false);

                                if (repair.repair_status !== 'repaired') {
                                    setShowStatusError(true);
                                    return;
                                }
                                if (!repair.repair_comment.trim()) {
                                    setShowError(true);
                                    return;
                                }
                                const updatedRepair = {
                                    ...defect,
                                    status: repair.repair_status,
                                    comment: repair.repair_comment,
                                    defect_type: repair.defect_type,
                                };
                                updateDefect(updatedRepair);
                                setShowDefects(false);
                            }}
                            style={{ marginTop: '10px', flex: 1, marginRight: '10px' }}
                        >
                            Submit
                        </button>
                    )}
                    <button
                        className="btn btn-secondary"
                        onClick={() => setShowDefects(false)}
                        style={{ marginTop: '10px', flex: 1 }}
                    >
                        {canEdit ? 'Cancel' : 'Close'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditDefectOverlay;
